import { CustomerData, RecoveryInformation } from 'interfaces/ApiTypeAliases';

export const userProfileMy = {
  username: 'mock_user',
  userId: 1,
  firstname: 'Mock',
  lastname: 'User',
} as const;

export const recoveryInformation: RecoveryInformation = {
  emailSettings: { isSignedUp: true, isVerified: false, emailAddress: 'sulun1@tdc.dk' },
  phoneSettings: { isSignedUp: true, isVerified: false, phoneNumber: '31677533' },
};

export const customers: CustomerData[] = [
  {
    id: '4891-07-15-13.09.26.813125',
    identity: {
      name: { firstname: 'Foo', lastname: 'Bar' },
      address: {
        street: 'Hamrandersvej',
        streetNumber: '1',
        city: 'Randers c',
        zipCode: '8900',
        streetCode: '9977',
        floor: '58',
        side: 'MF',
        houseLetter: '',
        apartmentNumber: '',
        municipalityCode: '730',
      },
    },
    communication: { generalEmail: 'jensh@nuuday.dk' },
    permissions: {
      operationalEmail: { emailAddress: 'miksc@yousee.dk', isAccepted: true },
      operationalSms: { phoneNumber: null, isAccepted: false },
      marketingEmail: { emailAddress: 'jensh+spam@nuuday.dk', isAccepted: true },
      marketingSms: { phoneNumber: '22222222', isAccepted: true },
      marketingCall: { phoneNumber: null, isAccepted: false },
    },
  },
  {
    id: '1711-11-11-13.33.23.814244',
    identity: {
      name: { firstname: 'Test', lastname: 'Test' },
      address: {
        street: 'Pileparken',
        streetNumber: '74',
        city: 'Brøndby',
        zipCode: '2605',
        streetCode: '494',
        floor: '',
        side: '',
        houseLetter: '',
        apartmentNumber: '',
        municipalityCode: '153',
      },
    },
    communication: { generalEmail: 'test+teståæø@gmail.com' },
    permissions: {
      operationalEmail: { emailAddress: null, isAccepted: false },
      operationalSms: { phoneNumber: '22733144', isAccepted: true },
      marketingEmail: { emailAddress: null, isAccepted: false },
      marketingSms: { phoneNumber: null, isAccepted: false },
      marketingCall: { phoneNumber: null, isAccepted: false },
    },
  },
  {
    id: '1121-12-05-13.38.49.714841',
    identity: {
      name: { firstname: 'Simon', lastname: 'Thorup' },
      address: {
        street: 'Blichers Alle',
        streetNumber: '3',
        city: 'Esbjerg c',
        zipCode: '6700',
        streetCode: '656',
        floor: '',
        side: '',
        houseLetter: '',
        apartmentNumber: '',
        municipalityCode: '561',
      },
    },
    communication: { generalEmail: 'jensh+spam@yousee.dk' },
    permissions: {
      operationalEmail: { emailAddress: null, isAccepted: false },
      operationalSms: { phoneNumber: null, isAccepted: false },
      marketingEmail: { emailAddress: null, isAccepted: false },
      marketingSms: { phoneNumber: null, isAccepted: false },
      marketingCall: { phoneNumber: '22733154', isAccepted: true },
    },
  },
];
